import { List } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTableConfig } from 'modules/Recommendations/Audits/subcomponents/Table/useTableConfig'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'
import { SEEN } from 'modules/Recommendations/Audits/types'
import EmptyResults from 'components/EmptyResults'
import styles from 'modules/Recommendations/Audits/audits.module.scss'
import { ReactComponent as NoDataFound } from 'images/illustration/no-data-found.svg'

const Table = ({ data, filters, checkboxHandleChange, checkedIDs, processingIds, loading }) => {
  const { t } = useTranslation([])
  const breakpoints = useBreakpoint()
  const dispatch = useDispatch()

  const setSeen = useCallback(
    (id = null) =>
      dispatch({
        type: SEEN,
        payload: [id],
      }),
    [],
  )

  const archiveView = useMemo(() => filters.status === 'archived', [filters])

  const [columnVisibility, setColumnVisibility] = useState()

  useEffect(() => {
    switch (true) {
      case breakpoints.sm:
        setColumnVisibility({ is_new: false, view: false })
        break
      case breakpoints.mds:
        setColumnVisibility({ is_new: false })
        break
      default:
        setColumnVisibility({})
        break
    }
  }, [breakpoints, archiveView])

  const { tableState, tableConfig } = useTableConfig(
    {
      archiveView,
      checkboxHandleChange,
      filters,
      setSeen,
      meta: { checkedIDs, processingIds },
    },
    data,
  )

  useEffect(() => {
    tableState.setState((prevState) => ({ ...prevState, columnVisibility }))
  }, [columnVisibility])

  return (
    <List
      table={tableState}
      config={tableConfig}
      loading={loading}
      EmptyComponent={() => (
        <EmptyResults
          className={styles['recommendations-list_empty']}
          image={<NoDataFound />}
          header={t('audits::empty_list.header')}
          text={t('audits::empty_list.text')}
        />
      )}
    />
  )
}

Table.propTypes = {
  data: PropTypes.array,
  checkboxHandleChange: PropTypes.func,
  filters: PropTypes.object,
  checkedIDs: PropTypes.array,
  processingIds: PropTypes.array,
  loading: PropTypes.bool,
}

export default Table
